import { FormField } from 'sos-common/js/commonTypes';
import { FieldName } from '../Types/Intyg.enums';
import { isDateValid } from 'sos-common/js/utils/date';

enum ERROR {
  EMAIL_NOT_MATCHING = 'error_email_not_matching',
  WRONG_EMAIL_ADDRESS = 'error_wrong_email_address',
  EMAIL_DISALLOWED_CHARS = 'error_email_disallowed_chars',
  MANDATORY = 'error_mandatory',
  MAX_LENGTH = 'error_max_length',
  INVALID_PERSONNUMMER = 'error_invalid_personnummer',
  INVALID_PERSONNUMMER_DATE = 'error_correct_date',
  FUTURE_DATE = 'error_future_date',
  OLD_DATE = 'error_invalid_century',
  ONLY_NUMBERS_ALLOWED = 'error_only_numbers_allowed',
  INVALID_PHONE_NUMBER = 'error_invalid_phone_number',
  DATE_FORMAT = 'error_date_format',
}

export const MAX_LENGTH_NUM = 255;
const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zåäöA-ZÅÄÖ\-0-9]+\.)+[a-zåäöA-ZÅÄÖ]{2,}))$/;
const disallowedChars = ['å', 'Å', 'ä', 'Ä', 'ö', 'Ö'];

export function validateField(field: FormField<any>): string {
  if (field.isRequired && noValue(field.value)) return ERROR.MANDATORY;

  if (!noValue(field.value)) {
    switch (field.fieldName) {
      case FieldName.Epost:
        return validateEmail(field);
      case FieldName.Bekraftaepost:
        return validateConfirmEmail(field);
      case FieldName.Personnummer:
        return validatePersonnummer(field);
      case FieldName.Postnummer:
      case FieldName.Examensar:
      case FieldName.Utbildningstid:
        return validateOnlyNumbers(field);
      // case FieldName.Telefon:
      //   return validatePhoneNumber(field);
      // case FieldName.LegitimeradFran:
      // case FieldName.DatumSpecialist:
      // case FieldName.DatumSpecialist_2:
      // case FieldName.SpecialExamensDatum:
      // case FieldName.SpecialDatum:
      //   return validateDateFormat(field);
    }
  }

  // return empty string if everything is valid
  return '';
}

function noValue(value: any) {
  return value === '' || value === undefined || value === null || value?.length === 0;
}

function validateEmail(email: FormField<string>): string {
  if (!EMAIL_PATTERN.test(email.value)) return ERROR.WRONG_EMAIL_ADDRESS;
  let foundDisallowedChars = false;
  disallowedChars.forEach((char) => {
    if (email.value.includes(char)) foundDisallowedChars = true;
  });
  if (foundDisallowedChars) return ERROR.EMAIL_DISALLOWED_CHARS;
  return '';
}

function validateConfirmEmail(email: FormField<string>): string {
  if (email.value !== email.referenceValue) return ERROR.EMAIL_NOT_MATCHING;
  return '';
}

function validatePersonnummer(field: FormField<string>): string {
  // format should match: ÅÅÅÅMMDD or ÅÅÅÅMMDD-XXXX
  let isValid = field.value?.match(/^\d{8}-\d{4}$|^\d{8}$/);
  if (!isValid) return ERROR.INVALID_PERSONNUMMER;

  const year = field.value.slice(0, 4);
  const month = field.value.slice(4, 6);
  const day = field.value.slice(6, 8);

  if (!isDateValid(year, month, day)) return ERROR.INVALID_PERSONNUMMER_DATE;

  const date = `${year}-${month}-${day}`;

  if (Date.parse(date) > Date.now()) return ERROR.FUTURE_DATE;
  if (parseInt(year) < 1900) return ERROR.OLD_DATE;

  return '';
}

function validateOnlyNumbers(field: FormField<string>) {
  // should match: digits, ignoring whitespace
  const isValid = field.value?.replace(/\s/g, '').match(/^\d+$/);
  if (!isValid) return ERROR.ONLY_NUMBERS_ALLOWED;
  return '';
}

function validatePhoneNumber(field: FormField<string>) {
  // should match: optional leading +, followed by (, space, digits, ) or -, 6 - 26 characters long
  const isValid = field.value?.match(/(^\+?[(| |\d|)|-]{6,26})$/);
  if (!isValid) return ERROR.INVALID_PHONE_NUMBER;
  return '';
}

function validateDateFormat(field: FormField<string>) {
  // should match: ÅÅÅÅ-MM-DD
  const isValid = field.value?.match(/^(\d{4}-\d{2}-\d{2})$/);
  if (!isValid) return ERROR.DATE_FORMAT;
  return '';
}
